import { type ButtonProps } from '@pets-ui/Button/Button'
import { Button } from '@pets-ui/Button/Button'
import { SvgIcon } from '@pets-ui/SvgIcon/SvgIcon'
import { colors } from '@pets-ui/tokens/colors.stylex'
import * as stylex from '@stylexjs/stylex'
import { useTranslation } from 'react-i18next'
import { LineLogo, LineWhiteLogo } from '../login/icons'

const styles = stylex.create({
  startIcon: {
    position: 'absolute',
    left: '16px',
  },
  subscribeButton: {
    backgroundColor: '#08BF5B',
    color: colors.white,
    height: '40px',
  },
  unsubscribeButton: {
    borderColor: '#08BF5B',
    borderStyle: 'solid',
    borderWidth: '1px',
    backgroundColor: colors.white,
    color: '#08BF5B',
    height: '40px',
  },
})

interface DialogSubscribeLineProps extends ButtonProps {
  isSubscribed?: boolean
}

export function ButtonSubscribeLine(props: DialogSubscribeLineProps) {
  const { t } = useTranslation()
  const { isSubscribed = false, ...rest } = props
  return (
    <Button
      fullWidth
      rootStyle={isSubscribed ? styles.unsubscribeButton : styles.subscribeButton}
      xStyles={{ startIcon: styles.startIcon }}
      startIcon={<SvgIcon fontSize={20}>{isSubscribed ? <LineLogo /> : <LineWhiteLogo />}</SvgIcon>}
      {...rest}
    >
      {isSubscribed ? t('login.subscribedLineButton') : t('login.subscribeLineButton')}
    </Button>
  )
}
